"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrentChapter = void 0;
const react_1 = __importStar(require("react"));
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const Tooltip_1 = __importDefault(require("@material-ui/core/Tooltip"));
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
const SkipPrevious_1 = __importDefault(require("@material-ui/icons/SkipPrevious"));
const SkipNext_1 = __importDefault(require("@material-ui/icons/SkipNext"));
const shared_spaced_group_1 = require("@guidde-co/shared.spaced-group");
const useStyles = (0, makeStyles_1.default)({
    wrapper: {
        width: '100%'
    },
    chapterName: {
        fontWeight: 500,
        marginRight: '8px',
        display: '-webkit-box',
        '-webkit-line-clamp': 1,
        '-webkit-box-orient': 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        wordBreak: 'break-word'
    },
    chapterNumber: {
        fontWeight: 500,
        marginRight: '4px'
    }
});
exports.CurrentChapter = (0, react_1.memo)(({ onUpdateTime, chapters, currentTime }) => {
    var _a, _b;
    const classes = useStyles();
    const [activeChapter, setActiveChapter] = (0, react_1.useState)(0);
    (0, react_1.useEffect)(() => {
        const index = chapters === null || chapters === void 0 ? void 0 : chapters.findIndex(chapter => chapter.end > currentTime);
        if (index === activeChapter)
            return;
        if (index === -1)
            return setActiveChapter(chapters.length - 1);
        setActiveChapter(index);
    }, [chapters, currentTime, activeChapter]);
    if ((chapters === null || chapters === void 0 ? void 0 : chapters.length) === 0)
        return null;
    return (react_1.default.createElement(shared_spaced_group_1.SpacedGroup, { className: classes.wrapper },
        react_1.default.createElement(Box_1.default, { display: "flex" },
            react_1.default.createElement(IconButton_1.default, { onClick: () => {
                    var _a;
                    onUpdateTime((_a = chapters[activeChapter - 1]) === null || _a === void 0 ? void 0 : _a.start);
                }, size: "small", style: { color: 'white' }, disableRipple: true, disabled: activeChapter === 0 },
                react_1.default.createElement(SkipPrevious_1.default, null)),
            react_1.default.createElement(IconButton_1.default, { onClick: () => {
                    var _a;
                    onUpdateTime((_a = chapters[activeChapter + 1]) === null || _a === void 0 ? void 0 : _a.start);
                }, size: "small", style: { color: 'white' }, disableRipple: true, disabled: activeChapter === chapters.length - 1 },
                react_1.default.createElement(SkipNext_1.default, null))),
        react_1.default.createElement(Tooltip_1.default, { title: (_a = chapters[activeChapter]) === null || _a === void 0 ? void 0 : _a.title },
            react_1.default.createElement(Typography_1.default, { variant: "body2", className: classes.chapterName },
                activeChapter + 1,
                "/",
                chapters.length,
                "\u00A0", (_b = chapters[activeChapter]) === null || _b === void 0 ? void 0 :
                _b.title))));
});
//# sourceMappingURL=current-chapter.js.map